import type { FaireProductEntity } from "../../entity_types/product";

export const p_xdefxx8xm4: FaireProductEntity = {
  token: "p_xdefxx8xm4",
  type: "product",
  name: "I Suck At Fantasy Football Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/330ac8e232a8870ccdfd9b45ce2eaf8898ba5bbf39f0adf7c1d18604e87fc588.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/550f12cdcd4be7b2e1f9f1fd7cfb75a197b758a384ade2c37e650b747e2d759d.jpeg",
    "https://cdn.faire.com/fastly/22fea158462ebae93edba378a058a9c440fbed7cbc33639c7ef695797ad9dff7.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/0bc949541599e0250a7b40bc1e411ae7f9a73aa946c7cc5fe8f5388c894688e4.jpeg",
    "https://cdn.faire.com/fastly/da937aa4ddf7fcaa0941d4c669d21afa02c2cfbf685a725e0ac3dd5f38ee8a5a.jpeg",
    "https://cdn.faire.com/fastly/6398c1364f69d4b1c74367c8b42f95b7174458b8ecaf0ce53859bdc5b8f6d9b6.jpeg"
  ],
  priceDollars: 6.75,
  description: "You may be the league’s biggest loser—but you can still have the best socks. Wear your shame. Comfortably.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:30.433Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
